module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAANlBMVEUAAAAzMzM0NDQzMzMwMDAyMjIzMzMyMjIzMzMyMjI1NTUwMDAyMjIzMzMzMzM0NDQzMzM0NDQfRsSjAAAAEnRSTlMA/0DvEH+gwN9gMCBwsNBPkIC7aMbxAAAAhUlEQVR4nG2QQRbDIAhEHTGIRk16/8uWqDW06V8I72+G0S32/d4nLwJk+3YMYRawdQkcnAsVychG6tRSMxJxzIg/sllZka+RUY30EK+vQF8bD9JLbfjV54zxfHZ6EI6tc/RzB1kwkX7FKELFdwqNakq5UxPK3Nj0WB9lG38Ku2x6+JX0yxtDtwKYqzU3wwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/user.png
// module id = vFdb
// module chunks = 0